module.exports = __webpack_public_path__ + "img/menu.46c86544.png";